/**
 * App/Account Store actions module.
 */
import apiAccount from '@/apps/account/api'
import apiOrg from '@/apps/org/api/orgstructure'
import apiWorksheet from '@/apps/org/api/anketa'

export default {
  /**
   * Get account profile
   * 
   * If profile exists return it
   * Otherwise load profile from server
   * 
   * @param {*} param0 
   */
  getProfile({ state, commit, getters }) {
    return new Promise((resolve, reject) => {
      if (getters['isAccountActive']) {
        resolve(state.profile)
      } else {
        apiAccount.getProfile().then(profile => {
          // Save profile data in the Store
          if(!profile.image) profile.image = ''
          commit('setProfile', profile)
          resolve(profile)
        }).catch(error => {
          reject(error)
        })
      }
    })
  },

  loadProfile({ state, commit, getters }) {
    return new Promise((resolve, reject) => {
      apiAccount.getProfile().then(profile => {
        // Save profile data in the Store
        commit('setProfile', profile)
        
        resolve(profile)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateProfile({ state, commit, getters }, profile) {
    return new Promise((resolve, reject) => {
      const fullProfile = Object.assign({}, state.profile, profile)

      apiAccount.updateProfile(profile).then(response => {
        // Save profile data in the Store
        commit('setProfile', fullProfile)
        resolve(fullProfile)
      }).catch(error => {
        reject(error)
      })
    })
  },

  loadSessions({ commit, getters }) {
    return new Promise((resolve, reject) => {
      apiAccount.getSessions().then(sessions => {
        // Save profile data in the Store
        commit('setSessions', sessions)
        resolve(sessions)
      }).catch(error => {
        reject(error)
      })
    })
  },

  loadCompanies({ commit, getters }) {
    return new Promise((resolve, reject) => {
      apiOrg.getCompanies().then(companies => {
        // Save data in the Store
        commit('setCompanies', companies)
        
        resolve(companies)
      }).catch(error => {
        // console.warn(error)
        reject(error)
      })
    })
  },

  getCompanies({ commit, getters }) {
    return new Promise((resolve, reject) => {
      let companies = getters['getCompanies']
      if (Array.isArray(companies) && companies.length > 0) {
        resolve(companies)
      } else {
        apiOrg.getCompanies().then(companies => {
          // Save data in the Store
          commit('setCompanies', companies)
          
          resolve(companies)
        }).catch(error => {
          // console.warn(error)
          reject(error)
        })
      }
    })
  },

  /**
   * Загрузка данных анкеты
   * @param {*} param0
   */
  loadAnketa({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiWorksheet.getAnketa(id).then(anketa => {
        // Save data in the Store
        commit('setAnketa', anketa)
        resolve(anketa)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * Загрузка прав доступа
   * @param {*} param0
   */
  loadAccesses({ dispatch, commit, getters, state }) {
    return new Promise((resolve, reject) => {
      apiOrg.getAccesses(getters.getPostId).then(data => {
        // Save data in the Store
        commit('setAccesses', data.accesses ? data.accesses : [])
        commit('setServices', data.services ? data.services : [])

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  checkAccess({ commit, getters }, postId) {
    return new Promise((resolve, reject) => {
      apiOrg.checkAccess(postId).then(response => {        
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  loadLogo({ commit, getters }, postId = '') {
    return new Promise((resolve, reject) => {
      apiOrg.getLogo(postId).then(logo => {
        // Save logo data in the Store
        commit('setLogo', logo)
        resolve(logo)
      }).catch(error => {
        reject(error)
      })
    })
  },

  signIn({ commit, getters }, { email, password }) {
    return new Promise((resolve, reject) => {
      apiAccount.signIn(email, password).then(response => {
        resolve(response)
      }).catch(error => {
        // console.warn(error)
        reject(error)
      })
    })
  },
  
  signUp({ commit, getters }, { email, password, confirm }) {
    return new Promise((resolve, reject) => {
      apiAccount.signUp(email, password, confirm).then(response => {
        resolve(response)
      }).catch(error => {
        // console.warn(error)
        reject(error)
      })
    })
  },
  
  signOut({ commit, getters, state }) {
    return new Promise((resolve, reject) => {
      apiAccount.signOut().then(response => {
        // TODO: Clear state
        // state.profile = {}
        // state.accountId = null
        commit(`setProfile`, {})
        commit(`setAccountId`, null)
        commit(`setCompanyId`, null)
        commit(`setPostId`, null)
        commit(`setCompanies`, [])
        
        resolve(response)
      }).catch(error => {
        // console.warn(error)
        reject(error)
      })
    })
  },

  check({ commit, getters }) {
    return new Promise((resolve, reject) => {
      apiOrg.check().then(response => {        
        response = Boolean(response)
        resolve(response)
      }).catch(error => {
        // resolve(false)
        // console.warn(error)
        reject(error)
      })
    })
  },
  
  
  refreshToken({ commit, dispatch, getters }) {
    if (getters.isRefreshing) {
      return getters.refreshingCall;
    }
    commit('setRefreshingState', true);
    let refresh_token = getters.getAuthTokens.refresh_token
    const refreshingCall = apiAccount.refreshToken(refresh_token).then( response => {
      //Записать новые токены в LocalStorage и Store
      if (localStorage) {
        localStorage.setItem("dms_auth_tokens", JSON.stringify(response))
      }
      commit('setAuthTokens', response)
      commit('setRefreshingState', false);
      commit('setRefreshingCall', undefined);
      return Promise.resolve(true);
    });
    commit('setRefreshingCall', refreshingCall);
    return refreshingCall;
  },
  
  getThemes({commit}){
    return new Promise((resolve, reject) => {
      apiAccount.getThemes().then( themes => {
        commit('setThemes', themes)
        resolve(themes)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  addTheme({commit}, theme){
    return new Promise((resolve, reject) => {
      apiAccount.createTheme(theme).then( response => {
        theme.id = response.id
        commit('addTheme', theme)
        resolve(theme)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  saveTheme({commit}, theme){
    return new Promise((resolve, reject) => {
      apiAccount.updateTheme(theme.id, theme).then( response => {
        commit('saveTheme', theme)
        resolve(theme)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  selectTheme({commit}, id){
    return new Promise((resolve, reject) => {
      apiAccount.selectTheme(id).then( response => {
        commit('selectTheme', id)
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  deleteTheme({commit, dispatch, getters, state}, id) {
    return new Promise((resolve, reject) => {
      apiAccount.deleteTheme(id).then( response => {
        if(getters['selectedTheme'].id === id){
          dispatch('selectTheme', '00000000-0000-0000-0000-000000000001')
        }
        commit('deleteTheme', id)
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // Payment
  getRates() {
    return apiAccount.getRates()
  },
  
  getHistory() {
    return apiAccount.getHistory()
  },

  paymentInit({}, order) {
    return apiAccount.paymentInit(order)
  },
  
  paymentDisable({}, order) {
    return apiAccount.paymentDisable(order)
  }
}



// WEBPACK FOOTER //
// ./src/apps/account/store/common/actions.js